import { useState, useEffect, useRef } from "react";
import { Box, Modal, Fade, Grid, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomSwitch from "../../shared/CustomSwitch";
import ViewAlertDetails from "./ViewAlertDetails";

const style = {
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%,-50%)",
  height: "500px",
  width: "680px",
  bgcolor: "#F8FAFB",
  border: "none",
  borderRadius: "6px",
};

const ViewAlert = ({ open, messages, handleClose, sentSuccess }) => {
  const messagesDetails = messages.map((message) => message);
  const messageRef = useRef(null); //component to print ref
  const [showOriginal, setShowOriginal] = useState(false);
  const showOriginalToggler = () => {
    setShowOriginal(!showOriginal);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      disableEnforceFocus
      disableAutoFocus
    >
      <Fade in>
        <Box sx={style}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{
              height: "64px",
              p: "15px",
              backgroundColor: "#050D2E",
              borderRadius: "6px 6px 0 0",
            }}
          >
            <Grid item>
              <Typography
                sx={{ color: "#ffffff", fontSize: "1.25rem", fontWeight: 550 }}
              >
                View Alert
              </Typography>
            </Grid>
            <Grid item>
              <CloseIcon
                sx={{ color: "#ffffff", cursor: "pointer" }}
                onClick={handleClose}
              />
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              overflow: "auto",
              marginTop: "initial",
              width: "initial",
              marginLeft: "initial",
              position: "relative",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                padding: "1rem",
                position: "sticky",
                top: 0,
                backgroundColor: "#F8FAFB",
                zIndex: 500,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <CustomSwitch
                  value={showOriginal}
                  onChange={showOriginalToggler}
                />
                <Typography
                  sx={{
                    fontSize: ".875",
                    fontWeight: 550,
                    color: "#050D2E",
                    marginLeft: "10px",
                  }}
                >
                  Show Original (RJE)
                </Typography>
              </Box>
            </Grid>
            <Grid item flexGrow={1} sx={{ padding: "1rem", paddingTop: 0 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  paddingTop: "1rem",
                }}
                ref={messageRef}
              >
                {messagesDetails.map((messageDetails, index) => {
                  return (
                    <div key={messageDetails.id} className="message">
                      <Box>
                        {showOriginal
                          ? messageDetails.generated === sentSuccess && (
                              <>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    bgcolor: "#ffffff",
                                    p: "2px",
                                    border: "1px solid #D3D8E3",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "0.875",
                                      padding: "10px",
                                    }}
                                  >
                                    {messageDetails.originalMessage}
                                  </Typography>
                                </Box>
                              </>
                            )
                          : messageDetails.generated === sentSuccess && (
                              <ViewAlertDetails
                                messageDetails={messageDetails}
                              />
                            )}
                      </Box>
                    </div>
                  );
                })}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ViewAlert;
